import { useEffect, useState } from 'react';

import { useDispatch, useSelector } from 'react-redux';

import { useParams } from 'react-router';

import { Box, Container, Grid, Step, StepLabel, Stepper } from '@mui/material';

import moment from 'moment';

import { RegistrarInformacionPage } from './RegistrarInformacionPage';
import { RegistrarPartesPage } from './RegistrarPartesPage';
import { RegistrarConceptosPage } from './RegistrarConceptosPage';
import { RegistrarAnexosPage } from './RegistrarAnexosPage';
import { GenerarAcusePage } from './GenerarAcusePage';

import DigitalizarDocumentosPage from './DigitalizarDocumentosPage';

import { Layout } from '../../../components/Layout';
import { CircularProgressIndicator } from '../../../components/CircularProgressIndicator';
import { BoxEnvioElectronico } from '../../../components/BoxEnvioElectronico';
import { BoxProcesoTerminado } from '../../../components/BoxProcesoTerminado';
import { BoxProcesoNoEncontrado } from '../../../components/BoxProcesoNoEncontrado';
import { BoxProcesoCancelado } from '../../../components/BoxProcesoCancelado';

import { setReducerLoading } from '../../../store/slices/LoadingSlice';

import { RootState } from '../../../store';

import { setReducerAnexos, setReducerPartes, setReducerConceptos, setReducerRecepcion } from '../../../store/slices/RecepcionSlice';

import { ActualizarEstatus, DetalleRecepcion } from '../../../connections/comun/RecepcionConnection';

export const DemandaInicialPage = ( ) => {

    const dispatch = useDispatch();

    const { open } = useSelector( ( state: RootState ) => state.loading );

    const { Id } = useParams();

    const [numeroSeguimiento, setNumeroSeguimiento] = useState(0);   

    const [activeStep, setActiveStep] = useState(0);    
    const [estatus, setEstatus] = useState(0);    

    const [procesoTerminado, setProcesoTerminado] = useState( false );
    const [procesoCancelado, setProcesoCancelado] = useState( false );
    const [procesoNoEncontrado, setProcesoNoEncontrado] = useState( false );
    const [mensajeFinalizacion, setMensajeFinalizacion] = useState( '' );
    const [mensajeAsignacion, setMensajeAsignacion] = useState( '' );

    const [envioElectronico, setEnvioElectronico] = useState( false );
    const [errorEnvioElectronico, setErrorEnvioElectronico] = useState( '' );

    const handleNext = () => {
        setActiveStep( (prevStep) => prevStep + 1);
    }

    const handleBack  = async () => {                        
        setActiveStep( (prevStep) => prevStep - 1);
    }

    const handleFinalizar = async () => {
                
        await ActualizarEstatus({ id: Id ?? '', idEstatus: 9 }).then( resp => {

            const { success, message } = resp;

            if( success ){

                setTimeout(() => {
                    
                    setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );    
                    setProcesoTerminado( true );

                }, 700);

            }
            else {

                setTimeout(() => {
                    
                    setErrorEnvioElectronico( message);
                    
                }, 700);

            } 

        });       
    
    }

    useEffect(() => {
    
        async function Obtener() {
            
            dispatch( setReducerLoading( { open: true } ) );

            setProcesoTerminado( false );   

            await DetalleRecepcion({ id: Id ?? '' }).then( resp => {

                setTimeout(() => {

                    const { success } = resp;

                    if( success ){

                        setNumeroSeguimiento( resp.idRecepcion ?? 0 );
                        setEnvioElectronico( resp.provieneBuzonElectronico ?? false );
                        setEstatus( resp.idEstatus ?? 0 );
                       
                        if( resp.idEstatus === 3 && resp.usuarioActualAsignacion ){ setActiveStep( 0 ); }
                        else if( resp.idEstatus === 4 && resp.usuarioActualAsignacion){ setActiveStep( 1 ); }
                        else if( resp.idEstatus === 5 && resp.usuarioActualAsignacion){ setActiveStep( 2 ); }
                        else if( resp.idEstatus === 6 && resp.usuarioActualAsignacion){ setActiveStep( 3 ); }
                        else if( resp.idEstatus === 7 && resp.usuarioActualAsignacion){ setActiveStep( 4 ); }
                        else if( resp.idEstatus === 8 && resp.usuarioActualAsignacion){ setActiveStep( 5 ); }
                        else if( resp.idEstatus === 9 ){  
                                    
                            setMensajeFinalizacion( 'No se tienen actividades pendientes para este trámite' );

                            if( resp.usuarioAsignacion ){
                                setMensajeAsignacion( 'La siguiente actividad se asignó a ' + ( resp.usuarioAsignacion ?? '' ) );  
                            }

                            setProcesoTerminado( true );                                 
                        }   
                        else if( resp.idEstatus === 10 ){
                            setProcesoCancelado( true );
                        }

                        if( !resp.usuarioActualAsignacion ){ 

                            if( resp.idEstatus !== 9 ){
                                setMensajeAsignacion( 'La siguiente actividad se asignó a ' + ( resp.usuarioAsignacion ?? '' ) );  
                                setProcesoTerminado( true ); 
                            }     
                        }  

                        dispatch( 
                            setReducerRecepcion({ 
                                ...resp, 
                                fechaRecepcion: resp.fechaRecepcion ? moment( resp.fechaRecepcion ).format("DD-MM-YYYY hh:mm a") : '', 
                                fechaReloj: resp.fechaReloj ? moment( resp.fechaReloj ).format("YYYY-MM-DDTHH:mm") : '', 
                                cuantia: resp.cuantia ?? '',
                            }) 
                        );
                        
                        dispatch( setReducerPartes({ partes: resp.partes ?? [] }) );
                        dispatch( setReducerConceptos({ conceptos: resp.conceptos ?? [] }) );
                        dispatch( setReducerAnexos({ anexos: resp.anexos ?? [] }) );
                        dispatch( setReducerLoading( { open: false } ) );

                    }
                    else {

                        setProcesoNoEncontrado( true );
                        dispatch( setReducerLoading( { open: false } ) );

                    }

                }, 700);   

            });

        }

        if( Id ){
            Obtener();
        }
        
    }, [ Id, dispatch ])  

    return (

        <Layout breadcrumbs={[ { text: 'Recibir trámite' }, { text: 'Demanda o escrito inicial' }]} optionTurno={true}>
  
            {
                open
                ?
                    <Box sx={{ textAlign: 'center', alignItems: 'center', minHeight: 580 }}>
                        <CircularProgressIndicator mt={30} />
                    </Box>
                :
                    ( procesoTerminado || procesoCancelado || procesoNoEncontrado )
                    ?
                        procesoNoEncontrado
                        ?   
                            <BoxProcesoNoEncontrado />
                        :
                            procesoCancelado
                            ?
                                <BoxProcesoCancelado />
                            :                   
                                <BoxProcesoTerminado message={ mensajeFinalizacion } messageAsignacion={ mensajeAsignacion } processEnd={ estatus === 9 } />                    
                    : 
                        <Box sx={{ my: 2 }}>

                            <Container maxWidth="xl">         

                                <Grid container>
                            
                                    <Grid size={{ md: 2 }} sx={{  }}>

                                        <Stepper activeStep={activeStep} orientation='vertical'>

                                            <Step sx={{ py: 2 }}>
                                                <StepLabel>Registrar información</StepLabel>
                                            </Step>

                                            <Step sx={{ py: 2 }}>
                                                <StepLabel>Registrar parte(s)</StepLabel>
                                            </Step>

                                            <Step sx={{ py: 2 }}>
                                                <StepLabel>Registrar prestación(es) o pretensión(es)</StepLabel>
                                            </Step>

                                            <Step sx={{ py: 2 }}>
                                                <StepLabel>Registrar anexo(s)</StepLabel>
                                            </Step>

                                            <Step sx={{ py: 2 }}>
                                                <StepLabel>Generar acuse de recibo</StepLabel>
                                            </Step>    

                                            {
                                                !envioElectronico
                                                &&
                                                    <Step sx={{ py: 2 }}>
                                                        <StepLabel>Escanear documento(s)</StepLabel>
                                                    </Step>                                        
                                            }                            

                                        </Stepper>   

                                    </Grid>        

                                    <Grid size={{ md: 10 }}>

                                        {
                                            envioElectronico && <BoxEnvioElectronico />
                                        }

                                        {
                                            activeStep === 0 ? (  
                                                            
                                                <RegistrarInformacionPage 
                                                    numeroSeguimiento={ numeroSeguimiento } 
                                                    handleNext={ handleNext } 
                                                />   

                                            ) :

                                            activeStep === 1 ? (                                           

                                                <RegistrarPartesPage 
                                                    numeroSeguimiento={ numeroSeguimiento } 
                                                    handleNext={ handleNext } 
                                                    handleBack={ handleBack } 
                                                />       

                                            ) :

                                            activeStep === 2 ? ( 

                                                <RegistrarConceptosPage 
                                                    numeroSeguimiento={ numeroSeguimiento } 
                                                    handleNext={ handleNext } 
                                                    handleBack={ handleBack } 
                                                />    

                                            ) :

                                            activeStep === 3 ? (

                                                <RegistrarAnexosPage 
                                                    numeroSeguimiento={ numeroSeguimiento } 
                                                    handleNext={ handleNext } 
                                                    handleBack={ handleBack } 
                                                    setAjaxFinish={ setProcesoTerminado }
                                                    setMensajeAsignacion={ setMensajeAsignacion }
                                                />       

                                            ) : 

                                            activeStep === 4 ? ( 

                                                <GenerarAcusePage 
                                                    numeroSeguimiento={ numeroSeguimiento }  
                                                    error={ errorEnvioElectronico }
                                                    handleNext={ handleNext } 
                                                    handleBack={ handleBack } 
                                                    setMensajeAsignacion={ setMensajeAsignacion } 
                                                    setAjaxFinish={ setProcesoTerminado }
                                                    setError={ setErrorEnvioElectronico }
                                                    Finalizar={ handleFinalizar }
                                                />    

                                            ) :

                                            activeStep === 5 ? (                                       

                                                <DigitalizarDocumentosPage 
                                                    handleBack={ handleBack }
                                                    setMensajeFinalizacion={ setMensajeFinalizacion } 
                                                    setMensajeAsignacion={ setMensajeAsignacion } 
                                                    setAjaxFinish={ setProcesoTerminado }
                                                    numeroSeguimiento={ numeroSeguimiento } 
                                                />      

                                            ) 
                                            
                                            : null  
                                                                
                                        }

                                    </Grid>
                                    
                                </Grid>   

                            </Container>

                        </Box>
            }

        </Layout>
    )
}
